import { useEffect } from "react";
import { getCurrentUserLocation } from "../helpers/geo";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { UserActions } from "../store/reducers/users";

/**
 * Refreshes the user's position every interval milliseconds.
 * Also updates the user's location in the Redux store.
 * @param interval - The interval between refreshes in milliseconds
 */
export const useRefreshedUserPosition = (interval: number = 10000) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const updateUserLocation = async () => {
            const location = await getCurrentUserLocation();
            if (location) {
                dispatch(UserActions.setUserLocation(location));
            }
        };

        updateUserLocation();
        const intervalId = setInterval(updateUserLocation, interval);
        return () => clearInterval(intervalId);
    }, [dispatch, interval]);

    return useAppSelector((state) => state.user.location);
}